/* For parachat window width in InterPals chat */

$(function () {
    setCookie('resolution', '', null);
    setCookie('resolution', screen.width + "x" + screen.height, 31536000);
});
